export default {
    facebook: "https://www.facebook.com/graciesferalcatrescue",
    instagram: "https://www.instagram.com/graciescatrescue",
    twitter: "https://twitter.com/graciesferalcatrescue",
    linkedin: "https://www.linkedin.com/company/graciesferalcatrescue",
    youtube: "https://www.youtube.com/graciesferalcatrescue",
    pinterest: "https://www.pinterest.com/graciesferalcatrescue",
    adoptionForm: "https://docs.google.com/forms/d/e/1FAIpQLSf_b4c8tPM-LbTM_tL0vsrQMuOp072K6vzktS0oX238W5WmyQ/viewform?usp=sf_link&embedded=true" 
}